export default "__VITE_ASSET__BKYZT4lu__"